export enum Intents {
  StartCall = 'StartCall',
  StartChat = 'StartChat',
  ViewChart = 'ViewChart',
  ViewContact = 'ViewContact',
  ViewQuote = 'ViewQuote',
  ViewNews = 'ViewNews',
  ViewInstrument = 'ViewInstrument',
  ViewAnalysis = 'ViewAnalysis',
}
